import * as types from './mutation-types'
import Vue from 'vue'
import { IRoleState } from './state'
import { MutationTree } from 'vuex/types'
import { AloDbRole, IAloDbRoleConstParam } from '@/models/alodb/AloDbRole';
import glider from '@/api/glider';
import {i18n} from '@/locale/vueI18n'

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations:MutationTree<IRoleState> = {
     
    //Gestion des recherches de missions
    [types.ROLE_REQUEST]: state => {
        state.status = i18n.t('Admin.Loading',{item:i18n.t('Admin.Role.Title').toString()}).toString()
        state.roleLoading = true
    },
    [types.ROLE_SUCCESS]: (state, roles:Array<AloDbRole>) => {
        state.status = i18n.t('Admin.LoadingOk',{item:i18n.t('Admin.Role.Title').toString()}).toString()
        state.roles = roles   
        state.roleLoading = false             
    },
    [types.ROLE_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.Role.Title').toString()}).toString()
        state.roles = []
        state.roleLoading = false
    },
    [types.ROLE_SELECT_DETAIL_REQUEST]: (state, itemId:number) => {
        state.status = i18n.t('Admin.Loading',{item:`${i18n.t('Admin.Role.Title').toString()} ${itemId}`}).toString()
        state.roleLoading = true
    },
    [types.ROLE_SELECT_DETAIL_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.Role.Title').toString()}).toString()
        state.roleLoading = false
    },
    [types.ROLE_SELECT_DETAIL_SUCCESS]: (state,role:AloDbRole) => {
        state.status = i18n.t('Admin.LoadingOk',{item:`${i18n.t('Admin.Role.Title').toString()} ${role.ROL_ID}`}).toString()        
        //1, on met à jour de m'role dans la liste des roles
        const index = state.roles.findIndex(m => m.ROL_ID == role.ROL_ID)
        state.roles.splice(index == -1 ? state.roles.length : index, index == -1 ? 0 : 1, role)
        state.roleLoading = false
    },
    [types.ROLE_SELECT_DETAIL]: (state,role:AloDbRole) => {                
        state.originalAdmRole = role
        state.modifiedAdmRole = new AloDbRole(role)
    },
    [types.ROLE_SAVE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.SaveItem',{item:`${i18n.t('Admin.Role.Title').toString()} ${libelle}`}).toString()
        state.roleLoading = true
    },
    [types.ROLE_SAVE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorSave',{item:i18n.t('Admin.Role.Title').toString()}).toString()
        state.roleLoading = false
    },
    [types.ROLE_UPDATE_MODIFIED_ADM]: (state, newProperties:Object) => {        
        state.modifiedAdmRole = {...state.modifiedAdmRole,...newProperties}
    },
    [types.ROLE_UPDATE_FILTER_ADM]: (state, newProperties:Object) => {        
        state.adminFilter = {...state.adminFilter,...newProperties}
    }           
}


export default mutations
